import { Placeholder } from 'react-bootstrap';
import CardLayout from '../../../../../shared/components/card/CardLayout';
import { DashUsersSkeleton } from '../../dashboard/components/CampaignDashboardSkeletons';

export function CampaignOverviewDetailSkeleton() {
    return (
        <Placeholder as="div" animation="glow" aria-hidden="true">
            <Placeholder className="skeleton skeleton-moonboard-image" />
            <div className="d-flex justify-content-between mt-3">
                <div className="mr-2">
                    <div className="d-flex mb-1">
                        {Array.from({ length: 3 }).map((_, i) => (
                            <Placeholder key={i} className="skeleton skeleton-platform-icon mr-1" />
                        ))}
                    </div>
                    <Placeholder className="skeleton skeleton-stat-label d-block" />
                </div>
                <div className="w-50">
                    <Placeholder xs={10} className="skeleton d-block mb-1" />
                    <Placeholder className="skeleton skeleton-stat-label d-block" />
                </div>
            </div>
            <div className="d-flex justify-content-between mt-3 pb-2 border-bottom mb-2">
                <div className="mr-2">
                    <Placeholder className="skeleton skeleton-stat-value d-block mb-1" />
                    <Placeholder className="skeleton skeleton-stat-label d-block" />
                </div>
                <div className="w-50">
                    <Placeholder xs={6} className="skeleton d-block mb-1" />
                    <Placeholder className="skeleton skeleton-stat-label d-block" />
                </div>
            </div>
        </Placeholder>
    );
}

export function DashboardRightSideSkeleton() {
    return (
        <CardLayout classCard="overflow-hidden">
            <CampaignOverviewDetailSkeleton />
            <div className="pb-2 border-bottom mb-2">
                <DashUsersSkeleton />
            </div>
            <div className="pb-2 border-bottom mb-2">
                <DashUsersSkeleton />
            </div>
            <div className="pb-2 border-bottom mb-2">
                <DashUsersSkeleton footer="end" />
            </div>
        </CardLayout>
    );
}
